import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import BackButtonComponent from "../../components/BackButtonComponent/BackButtonComponent";
import {
  ContainerIframe,
  ContainerReports,
  GeneralStyle,
  HR,
} from "./DetailGameContainer.styled";

const DetailGameContainer = () => {
  const location = useLocation();
  const history = useHistory();

  const iframe = `<iframe name="embed-feed" title="My Games" src="${location.state.url}" style="border: 0px; overflow: hidden; width: 100%; height: 100%; min-height: 610px;"></iframe>`;

  let goToBackPage = () => {
    history.push({ pathname: "/MyGames" });
  };

  return (
    <GeneralStyle>
      <BackButtonComponent
        backtitle={"My Games"}
        locationtitle={""}
        goToBackPage={goToBackPage}
        titleColor="#616161"
      />
      <HR />
      <ContainerReports>
        <ContainerIframe
          contentEditable="true"
          dangerouslySetInnerHTML={{ __html: iframe }}
        ></ContainerIframe>
      </ContainerReports>
    </GeneralStyle>
  );
};

export default DetailGameContainer;
